// ======================================================================
// File: src/modules/ipe/enquiry/components/EnquiriesTable.jsx
// ======================================================================

import React from "react";
import { useNavigate } from "react-router-dom";

export default function EnquiriesTable({ rows, loading, hasFilters, statusConfig }) {
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="text-center py-4 text-muted">
        Loading engineering enquiries…
      </div>
    );
  }

  if (!loading && rows.length === 0) {
    return (
      <div className="text-center py-4 text-muted">
        {hasFilters
          ? "No enquiries found for selected criteria"
          : "No engineering enquiries created yet"}
      </div>
    );
  }

  return (
    <table className="table table-hover mt-3">
      <thead className="table-light">
        <tr>
          <th>Enquiry No</th>
          <th>Customer</th>
          <th>Status</th>
          <th>Created At</th>
        </tr>
      </thead>

      <tbody>
        {rows.map((o) => {
          const status = statusConfig?.[o.status_code];

          return (
            <tr
              key={o.id}
              className="align-middle"
              style={{ cursor: "pointer" }}
              onClick={() => navigate(`/ipe/enquiries/${o.id}`)}
            >
              {/* ENQUIRY NO */}
              <td style={{ fontWeight: 500 }}>
                {o.enquiry_no}
              </td>

              {/* CUSTOMER */}
              <td>
                {o.customer_name || "-"}
              </td>

              {/* STATUS BADGE (SOFT UI) */}
              <td>
                {o.status_code ? (
                  <span
                    style={{
                      backgroundColor: status?.bg || "#e7f1ff",
                      color: status?.color || "#1d72f3",
                      padding: "6px 14px",
                      borderRadius: 20,
                      fontSize: 12,
                      fontWeight: 600,
                      display: "inline-block",
                      minWidth: 90,
                      textAlign: "center",
                      border: `1px solid ${status?.color || "#1d72f3"}20`
                    }}
                  >
                    {status?.label || o.status_code}
                  </span>
                ) : (
                  <span
                    style={{
                      background: "#f1f3f5",
                      color: "#6c757d",
                      padding: "6px 14px",
                      borderRadius: 20,
                      fontSize: 12,
                      fontWeight: 500
                    }}
                  >
                    N/A
                  </span>
                )}
              </td>

              {/* CREATED DATE */}
              <td>
                {o.created_at
                  ? new Date(o.created_at).toLocaleDateString()
                  : "—"}
              </td>

            </tr>
          );
        })}
      </tbody>
    </table>
  );
}